<template>
  <div>
    <Dialog :show.sync="visible" @close="visible = false">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="本月上门服务" name="currentMonthVisitUsers">
          <UserTable
            :list="visitUsers[activeName]"
            height="450"
            :visibleTotal="activeName == 'totalVisitUsers'"
          ></UserTable>
        </el-tab-pane>
        <el-tab-pane label="累计上门服务" name="totalVisitUsers">
          <UserTable
            :list="visitUsers[activeName]"
            height="450"
            :visibleTotal="activeName == 'totalVisitUsers'"
          ></UserTable>
        </el-tab-pane>
      </el-tabs>
      <div>
        <div class="mt-10">
          <!-- <el-input v-model="keyUser" placeholder="搜索用户">
            <div slot="suffix">
              <div
                :class="{
                  flex: true,
                  'justify-center': true,
                  'items-center': true,
                  'cursor-pointer': true,
                }"
                style="height: 42px; width: 50px"
              >
                <img
                  @click="onSearchUser"
                  style="width: 20px; height: 20px"
                  src="./img/search.png"
                  alt=""
                />
              </div>
            </div>
          </el-input> -->
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Dialog from "../common/Dialog.vue";
import UserTable from "../common/UserTable";
export default {
  data() {
    return {
      activeName: "currentMonthVisitUsers",
      tableData: {
        currentMonthVisitUsers: [],
        totalVisitUsers: [],
      },
      keyUser: "",
    };
  },
  props: {
    show: Boolean,
  },
  watch: {
    show(n) {
      if (n) {
        this.activeName = "currentMonthVisitUsers";
        // this.getList();
      }
    },
  },
  computed: {
    ...mapGetters(["visitUsers"]),
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
  },
  components: {
    Dialog,
    UserTable,
  },
  methods: {
    getList() {
      this.$axios
        .get("/statisticsService/mechanism/visitUsers")
        .then((resp) => {
          this.tableData = resp.data;
        });
    },

    onSearchUser() {},
    handleClick(value) {},
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .el-tabs__item {
    font-size: 24px !important;
    // color: #fff;
  }
  .is-active {
    color: #409eff !important;
  }
}
</style>
